import { useMutation, UseMutationResult } from 'react-query';
import api from '../../utils/api/api';
import { API_BOT_MESSAGE_ADMIN } from '../../utils/api/constants';
import { BotMessageForm } from '../../pages/admin/botMessage/constants';

export const useBotMessage = (): UseMutationResult<any, Error, BotMessageForm, unknown> => {
  return useMutation<any, Error, BotMessageForm>((botMessage: BotMessageForm) => api.post(API_BOT_MESSAGE_ADMIN, botMessage).then(res => res.data));
};
